/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS migration — "Request a Campaign". Shared across every Marketing
   sub-page (Marketing/Funnel, Pipeline Funnel, Email Marketing, LinkedIn/ABM),
   matching the real app: one request list visible from any of those pages.
   ──────────────────────────────────────────────────────────────────────────── */
import { createApi } from '@reduxjs/toolkit/query/react'
import { apiConstants, get, post, patchGeneric } from '../common/constants'

const CAMPAIGN_REQUESTS = apiConstants.GROWTHOS_ADMIN_MARKETING_CAMPAIGN_REQUESTS

const run = async (promise) => {
  try {
    const res = await promise
    return { data: res?.data }
  } catch (err) {
    const r = err?.response
    return {
      error: {
        status: r?.status,
        data: r?.data,
        message: r?.data?.message || err.message,
      },
    }
  }
}

export const growthosMarketingCampaignApiSlice = createApi({
  reducerPath: 'growthosMarketingCampaignApi',
  baseQuery: () => ({ data: undefined }),
  tagTypes: ['MarketingCampaignRequests'],
  endpoints: (b) => ({
    listMarketingCampaignRequests: b.query({
      queryFn: () => run(get(CAMPAIGN_REQUESTS)),
      providesTags: ['MarketingCampaignRequests'],
    }),
    createMarketingCampaignRequest: b.mutation({
      queryFn: (body) => run(post(CAMPAIGN_REQUESTS, body)),
      invalidatesTags: ['MarketingCampaignRequests'],
    }),
    updateMarketingCampaignRequestStatus: b.mutation({
      queryFn: ({ id, status }) => run(patchGeneric(`${CAMPAIGN_REQUESTS}/${id}`, { status })),
      invalidatesTags: ['MarketingCampaignRequests'],
    }),
  }),
})

export const {
  useListMarketingCampaignRequestsQuery,
  useCreateMarketingCampaignRequestMutation,
  useUpdateMarketingCampaignRequestStatusMutation,
} = growthosMarketingCampaignApiSlice
